/**
 * Loại cột - xác định editor
 */
export default {
  PaymentAdvance: 0, // Tạm ứng sang thực chi
  EstimateAdvance: 1, // Ứng trước chưa đủ ĐKTT sang Ứng trước đủ ĐKTT
  NotSelected: 3, // Không chọn
};
